import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { ToastrService } from 'ngx-toastr';
import { isNullOrUndefined } from 'util';
import {BehaviorSubject}  from 'rxjs';
import { EncdecService } from 'src/app/services/encdec.service';

declare const grecaptcha : any;
@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css']
})
export class ResetComponent implements OnInit {

  activespinner : boolean;
  passwordtext :any;
  showerrorpwd : any;
  showerrorcnpwd : any;
  captchaimage : any;
  validation : object = {username : true,password:true,confirmpassword : true,captcha : true,otp : true};
  UserData : object = {password:'',confirmpassword:'',username:'',otp:'',captcha:''};
  resetForm: FormGroup = this.fb.group({
    username: new FormControl(null, [Validators.required]),
    otp: new FormControl(null, [Validators.required]),
    password: new FormControl(null, [Validators.required]),
    confirmpassword: new FormControl(null, [Validators.required]),
  })
  constructor(
    private fb: FormBuilder,
    private authService : AuthloginService,
    private encdecservice : EncdecService,
    private constants : ConstantsModule,
    private toastr : ToastrService,
    private router : Router,
    private utils : UtilsModule
    ) { }

  ngOnInit() {
    this.passwordtext = this.constants.PASSWORD_STANDARD;
    // this.addScript();
    this.captchaimage = this.authService.getcaptchaimageapi();
    this.callCaptchaimage();
  }
  callCaptchaimage(){
    let imageObject = document.getElementById("capthaId");
    imageObject['src'] = this.captchaimage+'?time='+new Date();
  }
  submit(){
    if(this.basicValidation()){
      this.activespinner = true;
      if(this.UserData['password'] === this.UserData['confirmpassword']){
        var postdata = {};
        postdata['username'] = this.encdecservice.rsaenc(this.constants.PUBLIC_KEY,this.UserData['username']+","+this.UserData['password'])
        postdata['otp'] = this.resetForm.value['otp']
        postdata["captchaResponse"] = this.encdecservice.rsaenc(this.constants.PUBLIC_KEY,this.UserData['captcha']),
        this.authService.reset(postdata).subscribe(logresp =>{
          if(logresp.result.success)
           this.router.navigate(["/gis"]);
          else {
            this.toastr.error(logresp.result.message);
            this.UserData = {password:'',confirmpassword:'',username:'',otp:'',captcha:''};
            this.callCaptchaimage();
            // grecaptcha.reset();
          }
          this.activespinner = false;
        },function(err){
          this.activespinner = false;
          this.toastr.error(err)
        })
      } else {
        this.toastr.error('New Password and Confirm New Password should be same');
        this.activespinner = false;
      }
    
    }
    
  }
  public pswdValidate(pswd,str){
    let passw = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,}$/
        if(pswd.match(passw)) 
        { 
          str == 'password' ? this.showerrorpwd = false : this.showerrorcnpwd = false;
        } else{
          str == 'password' ? this.validation['password'] = true : this.validation['confirmpassword'] = true
          str == 'password' ? this.showerrorpwd = true : this.showerrorcnpwd = true;
        }
  }
  addScript() {
    let script = document.createElement('script');
    // const lang = this.lang ? '&hl=' + this.lang : '';
    script.src = `https://www.google.com/recaptcha/api.js?onload=reCaptchaLoad`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
  basicValidation(){
    if(this.utils.checkfield(this.UserData['username'])){
      this.validation['username'] = true;
    }else{
      this.validation['username'] = false;
    }

    if(this.utils.checkfield(this.UserData['password'])){
      this.validation['password'] = true;
    }else{
      this.validation['password'] = false;
    }
    if(this.utils.checkfield(this.UserData['captcha'])){
      this.validation['captcha'] = true;
    } else {
      this.validation['captcha'] = false;
    }
    if(this.utils.checkfield(this.UserData['otp'])){
      this.validation['otp'] = true;
    } else {
      this.validation['otp'] = false;
    }
    if(this.utils.checkfield(this.UserData['confirmpassword'])){
      this.validation['confirmpassword'] = true;
    } else {
      this.validation['confirmpassword'] = false;
    }

    return this.validation['password'] && this.validation['username'] 
    && this.validation['captcha'] && this.validation['otp'] && this.validation['confirmpassword'] && !this.showerrorcnpwd && !this.showerrorpwd;
  } 
}
